package gr.tech.meetinggenie.infrastructure.api

import gr.tech.meetinggenie.models.api.ApiResponse
import gr.tech.meetinggenie.models.meeting.MEETING_STATUS
import gr.tech.meetinggenie.models.meeting.MeetingDTO
import gr.tech.meetinggenie.models.meeting.MeetingFormDataDTO
import gr.tech.meetinggenie.models.meeting.MeetingResponseDTO
import gr.tech.meetinggenie.util.BACKEND
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json

suspend fun fetchMeeting(
    meetingId: Int,
    onSuccess: (MeetingDTO) -> Unit,
    onError: (String) -> Unit
) {
    val response = safeApiCallStringBody<MeetingDTO>(
        url = "${BACKEND.BACKEND_URL}${BACKEND.ROUTES.meetingById(meetingId)}"
    )
    if (response.success && response.data != null) {
        onSuccess(response.data)
    } else {
        onError(response.error?.message ?: "Error fetching meeting.")
    }
}

suspend fun fetchMeetings(
    skip: Int,
    status: MEETING_STATUS? = null,
    onSuccess: (List<MeetingDTO>) -> Unit,
    onError: (String) -> Unit
) {
    val statusParam = if (status != null) "&status=${status.short}" else ""
    val response = safeApiCallStringBody<List<MeetingDTO>>(
        url = "${BACKEND.BACKEND_URL}${BACKEND.ROUTES.MEETINGS}?skip=$skip$statusParam"
    )
    if (response.success && response.data != null) {
        onSuccess(response.data)
    } else {
        onError(response.error?.message ?: "Error fetching meetings.")
    }
}

suspend fun createMeeting(
    title: String,
    onSuccess: (MeetingDTO) -> Unit,
    onError: (String) -> Unit
) {
    val body = Json.encodeToString(MeetingDTO(title = title))
    val response = safeApiCallStringBody<MeetingDTO>(
        url = "${BACKEND.BACKEND_URL}${BACKEND.ROUTES.MEETINGS_CREATE}",
        method = "POST",
        body = body
    )
    if (response.success && response.data != null) {
        onSuccess(response.data)
    } else {
        onError(response.error?.message ?: "Error creating meeting.")
    }
}

suspend fun archiveMeeting(
    meetingId: Int,
    onSuccess: () -> Unit,
    onError: (String) -> Unit
) {
    val response = safeApiCallStringBody<Unit>(
        url = "${BACKEND.BACKEND_URL}${BACKEND.ROUTES.archiveMeeting(meetingId)}",
        method = "POST"
    )
    if (response.success) {
        onSuccess()
    } else {
        onError(response.error?.message ?: "Error archiving meeting.")
    }
}

suspend fun deleteMeeting(
    meetingId: Int,
    onSuccess: () -> Unit,
    onError: (String) -> Unit
) {
    val response = safeApiCallStringBody<Unit>(
        url = "${BACKEND.BACKEND_URL}${BACKEND.ROUTES.deleteMeeting(meetingId)}",
        method = "DELETE"
    )
    if (response.success) {
        onSuccess()
    } else {
        onError(response.error?.message ?: "Error deleting meeting.")
    }
}

suspend fun fetchMeetingResponses(
    meetingId: Int,
    onSuccess: (List<MeetingResponseDTO>) -> Unit,
    onError: (String) -> Unit
) {
    val response = safeApiCallStringBody<List<MeetingResponseDTO>>(
        url = "${BACKEND.BACKEND_URL}${BACKEND.ROUTES.meetingResponses(meetingId)}"
    )
    if (response.success && response.data != null) {
        onSuccess(response.data)
    } else {
        onError(response.error?.message ?: "Error fetching responses.")
    }
}

suspend fun fetchMyMeetingResponse(
    meetingId: Int,
    onSuccess: (MeetingResponseDTO) -> Unit,
    onError: (String) -> Unit
) {
    val response = safeApiCallStringBody<MeetingResponseDTO>(
        url = "${BACKEND.BACKEND_URL}${BACKEND.ROUTES.myResponse(meetingId)}"
    )
    if (response.success && response.data != null) {
        onSuccess(response.data)
    } else {
        onError(response.error?.message ?: "Error fetching your response.")
    }
}

suspend fun saveMeetingResponse(
    meetingId: Int,
    formData: MeetingFormDataDTO,
    onSuccess: (MeetingResponseDTO) -> Unit,
    onError: (String) -> Unit
) {
    val body = Json.encodeToString(formData)
    val response = safeApiCallStringBody<MeetingResponseDTO>(
        url = "${BACKEND.BACKEND_URL}${BACKEND.ROUTES.saveResponse(meetingId)}",
        method = "POST",
        body = body
    )
    if (response.success && response.data != null) {
        onSuccess(response.data)
    } else {
        onError(response.error?.message ?: "Error saving response.")
    }
}

suspend fun submitMeetingResponse(
    meetingId: Int,
    onSuccess: () -> Unit,
    onError: (String) -> Unit
) {
    val response = safeApiCallStringBody<Unit>(
        url = "${BACKEND.BACKEND_URL}${BACKEND.ROUTES.submitResponse(meetingId)}",
        method = "POST"
    )
    if (response.success) {
        onSuccess()
    } else {
        onError(response.error?.message ?: "Error submitting response.")
    }
}
